import {WinPresentationController} from "../WinPresentationController";
import {RockBottom} from "../../RockBottom";
import {RockBottomParsedGameData} from "../../server/data/RockBottomParsedGameData";
import {RockBottomParsedInitData} from "../../server/data/RockBottomParsedInitData";
import {gsap, TimelineLite} from "gsap";

export class XSplitController extends WinPresentationController {
    constructor() {
        super("XSplitController", true);
    }

    protected hasWin(): boolean {
        if (RockBottom.inBonusGame) {
            return false;
        }

        const parsedGameData: RockBottomParsedGameData = RockBottom.model.parsedGameData,
            parsedInitData: RockBottomParsedInitData = RockBottom.model.parsedInitData;

        let parsedReels: string[][] = parsedGameData.reels;

        if (RockBottom.isRestoredOnPick()) {
            parsedReels = parsedInitData.reels;
        }

        let flag: boolean = false;

        for (let reelId: number = 0; reelId < parsedReels.length; reelId++) {
            const currReelSet: string[] = parsedReels[reelId].slice(1, -1);
            if (currReelSet.includes("XS")) {
                flag = true;
                break;
            }
        }
        return flag;
    }

    protected async createWinAnimation(): Promise<any> {
        const tl: gsap.core.Timeline = gsap.timeline(),
            parsedData: RockBottomParsedGameData | RockBottomParsedInitData = RockBottom.getParsedData(),
            parsedReels: string[][] = parsedData.reels;

        if (RockBottom.isRestoredOnPick()) {
            this.xSplitOnRestore()
        } else {
            tl.add(this.performXSplit(parsedReels));
        }

        await tl;
    }

    protected skip() {
        RockBottom.xSplitView.abortXSplit();
    }

    private xSplitOnRestore(): void {
        const tl: gsap.core.Timeline = gsap.timeline(),
            parsedInitData: RockBottomParsedInitData = RockBottom.model.parsedInitData,
            parsedReels: string[][] = parsedInitData.reels;

        tl.add(this.performXSplit(parsedReels));
    }

    private performXSplit(parsedReels: string[][]): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.to(this, {duration: 0.3}); // added for abort
        tl.add(()=>{
            const insertTime = tl.duration();
            for (let reelId: number = 0; reelId < parsedReels.length; reelId++) {
                const currReelSet: string[] = parsedReels[reelId].slice(1, -1);
                if (currReelSet.includes("XS")) {
                    const symId: number = currReelSet.indexOf("XS");
                    if(RockBottom.xSplitView.isSkipped()) {
                        tl.add(RockBottom.xSplitView.playHighlightAnimation(reelId, symId), insertTime);
                    }else {
                        tl.to(this, {
                            duration: 1, // time required for single xSplit animation with all symbol split
                            onStart: ()=>{
                                RockBottom.xSplitView.playHighlightAnimation(reelId, symId);
                                if(RockBottom.xSplitView.isSkipped()) {
                                    tl.progress(1);
                                    tl.pause();
                                    tl.kill();
                                }
                            }
                        });
                    }
                }
            }
        }, 0.3);

        return tl;
    }
}